import { faClockRotateLeft, faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { InfoTooltip } from '@karnov/kui-react'

import { useCallback } from 'react'

import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useTranslation } from 'services/i18n'

import { useIsPanelOpen, useTogglePanel } from 'stores/usePanelsStateStore'

import { ConversationsHistoryLink } from './ConversationsHistoryLink'

import type { FC } from 'react'

export const ConversationHistoryHeader: FC = () => {
  const { t } = useTranslation()

  const triggerEvent = useTriggerEvent()

  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')
  const togglePanel = useTogglePanel()

  const handleConversationHistoryClick = useCallback(() => {
    togglePanel('conversations_menu')
    triggerEvent({
      name: 'kai_sidepanel_opened',
    })
  }, [togglePanel, triggerEvent])

  if (isConversationMenuPanelOpen) {
    return (
      <div className="mb-1 mt-3 flex w-full items-center justify-start pl-2 font-medium text-default">
        {t('conversation_history.history')}
        <span className="ml-2 text-sm font-normal text-subdued">{t('conversation_history.history_expiration_time')}</span>
        <InfoTooltip content={t('conversation_history.history_tooltip')}>
          <FontAwesomeIcon size="sm" icon={faInfoCircle} className="ml-1 text-subdued" />
        </InfoTooltip>
      </div>
    )
  }

  return (
    <ConversationsHistoryLink
      icon={<FontAwesomeIcon icon={faClockRotateLeft} />}
      tooltipContent={t('conversation_history.open_conversation_history_panel')}
      onClick={handleConversationHistoryClick}
      titleShort={t('conversation_history.history_short')}
      title=""
    />
  )
}
